import React from 'react';
import UpdateAccount from './components/account/UpdateAccount';
import CopyrightUpdateWeb from './components/editor/CopyrightUpdateWeb';
import HistoricCopyright from './components/historic/HistoricCopyright';
import HistoricWebsite from './components/historic/HistoricWebsite';
import HistoricInvoice from './components/historic/HistoricInvoice';
import HistoricEmail from './components/historic/HistoricEmail';
import HistoricListing from './components/historic/HistoricListing';


import CertifiedMail from './components/registration/CertifiedMail';
import Copyright from './components/registration/Copyright';
import CopyrightVideo from './components/registration/CopyrightVideo';
import CopyrightWeb from './components/registration/CopyrightWeb';
import CopyrightReceipt from './components/response/CopyrightReceipt';
import CopyrightWebReceipt from './components/response/CopyrightWebResponse';
import CopyrightVideoReceipt from './components/response/CopyrightVideoResponse';
import Menu from './components/controlpanel/Menu';
const ReloadYT = React.lazy(() => import('./components/editor/ReloadYoutube'));

const Dashboard = React.lazy(() => import('./pages/Dashboard'));

const CopyrightFiling = React.lazy(() => import('./pages/CopyrightForm'));
const CopyrightWebsite = React.lazy(() => import('./pages/CopyrightForm'));
const CopyrightVid = React.lazy(() => import('./pages/CopyrightForm'));
const CertifiedMailPage = React.lazy(() => import('./pages/CopyrightForm'));

const EditProfile = React.lazy(() => import('./pages/Edit'));
const EditWebsiteUrl = React.lazy(() => import('./pages/Edit'));

const CopyrightHistoric = React.lazy(() => import('./pages/Historic'));
const WebsiteHistoric = React.lazy(() => import('./pages/Historic'));
const InvoiceHistoric = React.lazy(() => import('./pages/Historic'));
const MailHistoric = React.lazy(() => import('./pages/Historic'));
const WebsiteList = React.lazy(() => import('./pages/Historic'));
const ReloadYouT = React.lazy(() => import('./pages/Reload'));



const CopyrightSuccess = React.lazy(() => import('./pages/CopyrightSuccess'));

const routes = [
    { path: '/Dashboard', exact: true, name: 'Dashboard', component: Dashboard, subcomponent: Menu },
    { path: '/CopyrightFiling', exact: true, name: 'CopyrightFiling', component: CopyrightFiling, subcomponent: Copyright },
    { path: '/CopyrightWebsite', exact: true, name: 'CopyrightWebsite', component: CopyrightWebsite, subcomponent: CopyrightWeb },
    { path: '/CopyrightVideo', exact: true, name: 'CopyrightVideo', component: CopyrightVid, subcomponent: CopyrightVideo },
    { path: '/CertifiedMail', exact: true, name: 'CertifiedMail', component: CertifiedMailPage, subcomponent: CertifiedMail },
    { path: '/EditProfile', exact: true, name: 'EditProfile', component: EditProfile, subcomponent: UpdateAccount },
    { path: '/EditWebsiteUrl', exact: true, name: 'EditWebsiteUrl', component: EditWebsiteUrl, subcomponent: CopyrightUpdateWeb },
    { path: '/CopyrightHistoric', exact: true, name: 'CopyrightHistoric', component: CopyrightHistoric, subcomponent: HistoricCopyright },
    { path: '/WebsiteHistoric', exact: true, name: 'WebsiteHistoric', component: WebsiteHistoric, subcomponent: HistoricWebsite },
    { path: '/InvoiceHistoric', exact: true, name: 'InvoiceHistoric', component: InvoiceHistoric, subcomponent: HistoricInvoice },
    { path: '/MailHistoric', exact: true, name: 'MailHistoric', component: MailHistoric, subcomponent: HistoricEmail },
    { path: '/CopyrightResponse', exact: true, name: 'CopyrightResponse', component: CopyrightSuccess, subcomponent: CopyrightReceipt },
    { path: '/CopyrightWebResponse', exact: true, name: 'CopyrightWebResponse', component: CopyrightSuccess, subcomponent: CopyrightWebReceipt },
    { path: '/CopyrightVideoResponse', exact: true, name: 'CopyrightVideoResponse', component: CopyrightSuccess, subcomponent: CopyrightVideoReceipt },
    { path: '/WebsiteListing', exact: true, name: 'WebsiteListing', component: WebsiteList, subcomponent: HistoricListing },
    { path: '/ReloadYoutube', exact: true, name: 'ReloadYoutube', component: ReloadYouT, subcomponent: ReloadYT },
];

export default routes;